import { Box, Heading, Mark } from "@chakra-ui/react"
import { Logo } from "components/Logo"
import { formatReportPublishedDate } from "lib/helpers/reportPublishedDate"
import { useRating } from "lib/providers/RatingProvider"
import { FreeVersionWatermark, Page, SectionHeading } from "../../Report/components"

export const Frontpage = () => {
  const { ratingState } = useRating()

  return (
    <Page named="vsme-frontpage">
      <FreeVersionWatermark />
      <Logo />
      <Heading as="h1" fontSize="xxx-large" marginTop={600}>
        Bærekraftrapport
      </Heading>
      <SectionHeading width={300} paddingBottom={50}>
        Utarbeidet i tråd med VSME-standarden
      </SectionHeading>
      <Box fontSize="larger" fontWeight={500} mb={2}>
        {ratingState?.brreg?.navn}
      </Box>
      <Box fontSize="medium">
        <Mark color="white" fontWeight={500}>
          Org nr:{" "}
        </Mark>
        {ratingState?.brreg?.organisasjonsnummer}
      </Box>
      <Box fontSize="medium">
        <Mark color="white" fontWeight={500}>
          Rapportperiode:{" "}
        </Mark>
        <Box as="span" textTransform="lowercase">
          {ratingState?.period?.toPrettyString()}
        </Box>
      </Box>
      <Box fontSize="medium">
        <Mark color="white" fontWeight={500}>
          Publisert:{" "}
        </Mark>
        <Box as="span" textTransform="lowercase">
          {formatReportPublishedDate(ratingState)}
        </Box>
      </Box>
    </Page>
  )
}
